import PptxGenJS, { Slide } from "pptxgenjs"
import {createAnnuitySection} from "../annuity-generator"
import {createCapitalReimbursementSection} from "../capital-reimbursement-generator"
import {createInterestReimbursementSection} from "../interest-reimbursement-generator"
import {createRemainingCapitalSection} from "../remaining-capital-generator"
import * as CapaciteNetteGen from "./../capacite-nette-generator"
import * as CapaciteBruteGen from "./../capacite-brute-generator"
import * as OperationsDepenses from "./../depenses-generator"
import * as RecettesReelles from "./../recettes-generator"
import * as DepensesReelles from "./../depenses-reelles-generator"
import * as ResultatAnnee from "./../resultat-de-annee"
import * as OperationRecettes from "./../operations-recettes-generator"
import { ReportConfiguration } from "../../../configuration"
import { MasterSlide } from "../../pptx-configuration/master-slides"
import { Placeholder } from "../../pptx-configuration/placeholders"
import { DocumentSection } from "../../types"
import { formatTitle } from "../utils"
import * as Model from "../../../../../model"
import * as DebtUtils from "../utils"
import * as Constants from "../../pptx-configuration/constants"

export function createGlobelSection(
	pptx: PptxGenJS,
	configuration: ReportConfiguration,
	numbering: number[],
	childDecomposedLoans: any,
	years: number[],
    checked:string,
    decomposedLoans:any
): DocumentSection {

    const summarySlide = pptx.addNewSlide(MasterSlide.Default)
    const slides: Slide[] = []
	const subTitles: string[] = []
    const title = formatTitle("Compilation des Dettes Globales", numbering)
    const year = DebtUtils.createYears(configuration, decomposedLoans)
    summarySlide.addText(title, { placeholder: Placeholder.Title })

    let partNumber = 0

const annuitySection = createAnnuitySection(
    pptx,
    configuration,
    numbering.concat(++partNumber),
    childDecomposedLoans,
    year,
    checked
)
annuitySection.slides.forEach(s => slides.push(s))
subTitles.push(annuitySection.title)

const capitalReimbursementSection = createCapitalReimbursementSection(
    pptx,
    configuration,
    numbering.concat(++partNumber),
    childDecomposedLoans,
    year,
    checked
)
capitalReimbursementSection.slides.forEach(s => slides.push(s))
subTitles.push(capitalReimbursementSection.title)

const interestReimbursementSection = createInterestReimbursementSection(
    pptx,
    configuration,
    numbering.concat(++partNumber),
    childDecomposedLoans,
    year,
    checked
)
interestReimbursementSection.slides.forEach(s => slides.push(s))
subTitles.push(interestReimbursementSection.title)

const remainingCapitalSection = createRemainingCapitalSection(
    pptx,
    configuration,
    numbering.concat(++partNumber),
    childDecomposedLoans,
    year,
    checked
)
    remainingCapitalSection.slides.forEach(s => slides.push(s))
    subTitles.push(remainingCapitalSection.title)

    summarySlide.addText(
		subTitles.map(t => ({ text: t, options: { breakLine: true }})),
        Constants.getTextPlacementOptions
	)

	return { title, slides }
}



// WEBPACK FOOTER //
// ./src/component/management-report/generator/budgetGenerator/dettes-globales/index.tsx